import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const md5 = require('md5');
const moment = require('moment');

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  messages: string[] = [];

  add(message: string) {
    this.messages.push(message);
  }

  clear() {
    this.messages = [];
  }

  getSignatureObject() {
    let apiKey = environment.mashery_api_key;
    let apiSecret = environment.mashery_api_secret;
    let time = moment().unix();
    let signature = md5(apiKey + apiSecret + time);

    return { api_key: apiKey, sig: signature };
  }

  getTransactionId() {
    return 'TEST' +
      moment().unix() +
      Math.floor(Math.random() * 99999);
  }
}
